import axios from "axios";
import Cookies from "js-cookie";

const baseUrl = process.env.REACT_APP_API_URL;

export const getTenders = async (page) => {
  const url = baseUrl + `/getTenders`;
  try {
    const response = await axios.post(url, { page: page });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getSingleTender = async (id) => {
  const url = baseUrl + `/getSingleTender`;
  try {
    const response = await axios.post(url, { tenderId: id });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
